export default "__VITE_ASSET__12744882__"